import React from 'react';
import { SlRow, Text } from '@stackline/ui';
import ChevronLeft from '!svg-react-loader!./assets/chevronLeft.svg';
import ChevronRight from '!svg-react-loader!./assets/chevronRight.svg';

export interface PaginationProps {
  currentPage: number;
  totalPages?: number;
  onClickNext: () => void;
  onClickPrevious: () => void;
  // Cap Page is last page of the data, and we do not want to fetch extra pages
  // use this we do not want to show the total number of pages, but still have to stop the pagination at some point
  capPage?: number;
  shouldUseInfinitePagination?: boolean;
  disableNextButton?: boolean;
}

/**
 * Inside of the row, the icon is positioned
 * at the bottom of the div so this moves it up
 */
const iconStyle: React.CSSProperties = {
  position: 'relative',
  top: '2px',
  cursor: 'pointer'
};

/**
 * Shows page for paginated results and handles going to the next
 * and previous pages
 */
const Pagination = ({
  currentPage,
  onClickNext,
  onClickPrevious,
  totalPages,
  capPage,
  shouldUseInfinitePagination = false,
  disableNextButton = false
}: PaginationProps) => {
  const disablePrevious = currentPage === 1;
  const isCapPage = currentPage === capPage;
  const disableNext = shouldUseInfinitePagination
    ? disableNextButton || !shouldUseInfinitePagination
    : currentPage === totalPages;

  return (
    <SlRow spacing="xs" verticalPosition="center">
      <ChevronLeft
        style={{
          ...iconStyle,
          opacity: disablePrevious ? 0.4 : 1,
          pointerEvents: disablePrevious ? 'none' : 'auto'
        }}
        onClick={onClickPrevious}
        role="button"
      />
      <Text variant="subtitle3">
        Page {currentPage} {!shouldUseInfinitePagination && `of ${totalPages}`}
      </Text>
      <ChevronRight
        style={{
          ...iconStyle,
          opacity: disableNext || isCapPage ? 0.4 : 1,
          pointerEvents: disableNext || isCapPage ? 'none' : 'auto'
        }}
        onClick={onClickNext}
        role="button"
      />
    </SlRow>
  );
};

export default Pagination;
